import { Card, CardContent } from "@/components/ui/card";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { SEOHead } from "@/components/SEOHead";

export default function GoodFaithEstimate() {
  return (
    <div className="min-h-screen bg-background font-sans text-foreground flex flex-col">
      <SEOHead 
        title="Good Faith Estimate | Woods Spine & Wellness"
        description="Notice of Right to Receive a Good Faith Estimate under the No Surprises Act."
        canonical="https://woodsspine.com/goodfaithestimate"
      />
      <Navbar />
      <main className="flex-grow">
        <section className="bg-primary py-16 text-primary-foreground text-center">
          <div className="container mx-auto px-4">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Good Faith Estimate</h1>
            <p className="text-xl opacity-90">Notice of Right to Receive a Good Faith Estimate</p>
          </div>
        </section>

        <section className="py-16">
          <div className="container mx-auto px-4 max-w-4xl">
            <Card className="shadow-lg border-0">
              <CardContent className="p-8 md:p-12 prose prose-slate max-w-none">
                <p className="text-lg text-muted-foreground mb-8">
                  Under the law, health care providers need to give patients who don’t have insurance or who are not using insurance an estimate of the bill for medical items and services.
                </p>

                <ul className="list-disc pl-6 mb-6 space-y-4">
                  <li>
                    You have the right to receive a Good Faith Estimate for the total expected cost of any non-emergency items or services. This includes related costs like medical tests, prescription drugs, equipment, and hospital fees.
                  </li>
                  <li>
                    Make sure your health care provider gives you a Good Faith Estimate in writing at least 1 business day before your medical service or item. You can also ask your health care provider, and any other provider you choose, for a Good Faith Estimate before you schedule an item or service.
                  </li>
                  <li>
                    If you receive a bill that is at least $400 more than your Good Faith Estimate, you can dispute the bill.
                  </li>
                  <li>
                    Make sure to save a copy or picture of your Good Faith Estimate.
                  </li>
                </ul>

                <p className="mb-4">
                  For questions or more information about your right to a Good Faith Estimate, visit <a href="https://www.cms.gov/nosurprises" target="_blank" rel="noopener noreferrer" className="text-accent underline hover:text-accent/80">www.cms.gov/nosurprises</a> or contact our office.
                </p>

                <div className="bg-muted p-6 rounded-lg mt-8">
                  <p className="font-bold mb-2">Woods Spine & Wellness</p>
                  <p className="mb-1"><strong>Address:</strong> 530 E LOOP 281 STE 103, Longview, TX 75605</p>
                  <p className="mb-1"><strong>Phone:</strong> (903) 215-8828</p>
                  <p><strong>Email:</strong> woodsspine.office@gmail.com</p>
                </div>
              </CardContent>
            </Card>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
